<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{ tituloGrids }}</span>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0 pt-2">
        <Grid
          v-if="this.$store.state.token != ''"
          :tabla="TablaName"
          :nItemsPerPagina="10"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="false"
          :sIdTable="'id_correos'"
          :bShowMapDetails="false"
          :bActiveNew="false"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Grid from "@/components/Grid/Grid.vue";
import mxFunciones from "@/mixins/funciones.js";

export default {
  name: "CasosCorreos",
  mixins: [mxFunciones],
  components: {
    Grid,
  },
  data() {
    return {
      TablaName: "Caso_Correos", // Nombre de la tabla a trabajar
      tituloGrids: "",
    };
  },
  async mounted() {
    this.tituloGrids = await this.getTitulo(this.TablaName);
  },
};
</script>

<style lang="scss" scoped>
</style>